import { useEffect, useState } from "react";
import React from "react"
import { useTranslation } from "react-i18next";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from "@mui/material/TablePagination";
import { StyledTableCell, StyledTableRow } from "./StyledTable";
import FilterForm from "./FilterArchitectForm";
import { Loader } from "@egovernments/digit-ui-react-components";

function RegisteredArchitect() {
    const rowsPerPageOptions = [20];
    const { t } = useTranslation();
    const tenantId = Digit.ULBService.getStateId();
    const [engineersArr, setEngsArr] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);

    useEffect(async () => {
        const structualEngResponse = await Digit.UserService.userSearch(tenantId, { roleCodes: ["BPA_STRUCTURALENGINEER", "BPA_ARCHITECT"] });
        const users = structualEngResponse?.user.filter(user => !(['test', null].includes(user.registrationNumber)))
        setEngsArr(users)
    }, [])
    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div>
            <FilterForm />
            <div style={{ width: '90%', margin: 'auto' }}>
                {engineersArr.length === 0 ? <Loader /> : 
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>SL#</StyledTableCell>
                                <StyledTableCell align="center">Name</StyledTableCell>
                                <StyledTableCell align="center">Category</StyledTableCell>
                                <StyledTableCell>Class</StyledTableCell>
                                <StyledTableCell align="center">Address</StyledTableCell>
                                <StyledTableCell align="center">Email</StyledTableCell>
                                <StyledTableCell align="center">Mobile</StyledTableCell>
                                <StyledTableCell align="center">Regd.No</StyledTableCell>
                                <StyledTableCell align="center">Regd.Date</StyledTableCell>
                                <StyledTableCell align="center">Qualification</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(rowsPerPage > 0
                                ? engineersArr?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : engineersArr
                            ).map((row, index) => (
                                <StyledTableRow key={row?.id}>
                                    <StyledTableCell component="th" scope="row">
                                        {index + 1}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">{row?.name}</StyledTableCell>
                                    <StyledTableCell align="center">{'A'}</StyledTableCell>
                                    <StyledTableCell align="center">{'Architect'}</StyledTableCell>
                                    <StyledTableCell align="center">{row?.correspondenceAddress?.address}</StyledTableCell>
                                    <StyledTableCell align="center">{row?.emailId}</StyledTableCell>
                                    <StyledTableCell align="center">{row?.mobileNumber}</StyledTableCell>
                                    <StyledTableCell align="center">{row?.registrationNumber}</StyledTableCell>
                                    <StyledTableCell align="center">{new Date(row?.createdDate).toLocaleDateString() || ''}</StyledTableCell>
                                    <StyledTableCell align="center">{<a href="/" style={{color: '#8080FF'}}>View</a>}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                }
            </div>
            <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                component="div"
                count={engineersArr?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    )
}

export default RegisteredArchitect